<template>
  <div class="page">
    <div v-if="isEmpty"></div>
    <div class="result" v-else>
      <template v-if="status">
        <img src="@/assets/pay-success.png" alt="" srcset="" />
        <h2>{{ status ? $t("result.paySuccess") : $t("result.payFail") }}</h2>
        <div class="order">
          <div class="order-name">{{ $t("result.orderNo") }}</div>
          <div class="order-id">{{ orderId }}</div>
        </div>
        <div class="order pay" v-show="amount">
          <div class="order-name">{{ $t("result.payMoney") }}</div>
          <div class="order-id">{{ amount }}</div>
        </div>
        <div class="order" v-show="free_chance">
          <div class="order-name">{{ $t("result.giftAmount") }}</div>
          <div class="order-id">{{ free_chance }}</div>
        </div>
      </template>
      <template v-else>
        <img src="@/assets/pay-fail.png" alt="" srcset="" />
        <h2>{{ status ? $t("result.paySuccess") : $t("result.payFail") }}</h2>
      </template>
      <!-- <el-button
        type="primary"
        style="width: 200px; border-radius: 20px; margin-top: 40px"
        @click="close"
      >
        Quay lại
      </el-button> -->
    </div>
  </div>
</template>

<script>
import { Base64 } from "js-base64";
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      status: 0,
      orderId: "",
      amount: "",
      free_chance: "",
      isEmpty: true,
    };
  },
  computed: {},
  watch: {},
  created() { },
  mounted() {
    this.getRouteData();
  },
  methods: {
    getRouteData() {
      if (this.$route.query.status) {
        // this.status = Number(this.$route.query.status);
        Number(this.$route.query.status) === 1
          ? (this.status = 1)
          : (this.status = 0);
        this.orderId = this.$route.query.orderId;
        if (this.$route.query.status === "SUCCESS") {
          this.status = 1;
          this.orderId = this.$route.query.outTradeNo;
          if (this.$route.query.merchantOrderId) {
            this.orderId = this.$route.query.merchantOrderId
          }
        }
        this.isEmpty = false;
      } else if (this.$route.query.param) {
        const params = new URLSearchParams(
          Base64.decode(this.$route.query.param)
        );
        const obj = {};
        for (const [key, value] of params) {
          obj[key] = decodeURIComponent(value);
        }
        // this.status = obj.status;
        Number(obj.status) === 1 ? (this.status = 1) : (this.status = 0);
        this.orderId = obj.mch_order_id;
        this.amount = obj.amount;
        this.isEmpty = false;
      } else if (this.$route.query.vnp_ResponseCode) {
        Number(this.$route.query.vnp_ResponseCode) === 0
          ? Number((this.status = 1))
          : Number((this.status = 0));
        this.orderId = this.$route.query.vnp_TransactionNo;
        this.amount = this.$route.query.vnp_Amount;
        this.isEmpty = false;
      } else if (Number(this.$route.query.resultCode) === 0) {
        Number(this.$route.query.resultCode) === 0
          ? Number((this.status = 1))
          : Number((this.status = 0));
        this.orderId = this.$route.query.orderId;
        this.amount = this.$route.query.amount;
        this.isEmpty = false;
      } else if (this.$route.query.orderState == "01") {
        this.status = 1;
        this.orderId = this.$route.query.orderId;
        this.amount = this.$route.query.orderAmt;
        this.isEmpty = false;
      } else if (this.$route.query.gwId) {
        this.getPaySuccess(this.$route.query.gwId);
      } else {
        this.status = 0;
        this.isEmpty = false;
      }
    },
    //判断是否请求成功
    getPaySuccess(gwId) {
      let params = {
        gwId,
      };
      this.$http.get("/center/orderInfo", { params }).then((res) => {
        if (res.data.code == 200) {
          if (Number(res.data.data.pay_status) == 2) {
            this.status = 1;
            this.orderId = res.data.data.platform_orderno;
            this.amount = res.data.data.pay_amt + res.data.data.pay_unit;
          } else {
            this.status = 0;
          }
          this.isEmpty = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  height: 100vh;

  h2 {
    margin: 48px 0;
  }

  .result {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: auto;
  }

  .order {
    display: flex;
    width: 300px;
    justify-content: space-between;
    margin: 10px 0;

    .order-name {
      color: gray;
    }

    .order-id {
      width: 200px;
      text-align: right;
      word-wrap: break-word;
    }
  }
}
</style>
